// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"6bbf8c2c","3016":"872ab202","5477":"a7529c6b"}[chunkId] + ".chunk.css";
};